import { createApi } from '@reduxjs/toolkit/query/react';
import { transformErrorResponse, transformSucessResponse } from '../../utils/API/responseMiddleware';
import { defautBaseQuery } from '../../utils/API/fetchBaseQuery';
import { transformRequest } from '../../utils/API/requestMiddleware';

const authapi = createApi({
  baseQuery: defautBaseQuery, // Replace with your API endpoint
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (credentials) => ({
        url: '/Authentication/UserLogin', // Replace with your authentication endpoint
        method: 'POST',
        body: transformRequest(credentials)
      }),
      invalidatesTags: ['authentication'],
      transformResponse:transformSucessResponse,
      transformErrorResponse:transformErrorResponse 
    }),
      authVerifyOTP: builder.mutation({
            query: (data) => ({
                url: `/Authentication/AuthVerifyOtp`,
                method: 'POST',
                body: transformRequest(data)
            }),
            transformResponse:transformSucessResponse,
      transformErrorResponse:transformErrorResponse
        }),
    

  }),
});

export const { useLoginMutation ,useAuthVerifyOTPMutation} = authapi;
export default authapi;
